module.exports = __webpack_public_path__ + "media/images/lb/310-cb71881c86918f8703519ab1c4540191.svg";